// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  paymentAndTransactionFormSchema,
  PaymentAndTransactionValuesType,
  paymentAndTransactionInitialValues,
} from "./_formTypes";
import {
  useGetPayment3DTrxSettingsList,
  GetPaymentAndTransactionRequest,
  useGetPaymentAndTransaction,
  useCancelPaymentAndTransaction,
  CancelPaymentAndTransactionRequest,
  useRefundPaymentAndTransaction,
  RefundPaymentAndTransactionRequest,
  useGetTrxStatusSettingsList,
  PagingResponse,
  useAuthorization,
  useGetMerchantVPosList,
  useGetMemberVPosList,
  useGetMerchantsWithParentMerchant,
  usePostRequestReportForTransactionList,
  postTransactionReportRequestList
} from "../../../hooks";
import {
  GridColDef,
  GridActionsCellItem,
  GridValueFormatterParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  Link,
  Box,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
  Checkbox,
  Button as MaterialButton
} from "@mui/material";
import { Button, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DateTimePickerControl,
  InputControl,
  Table,
  DeleteConfirmModal,
  NumericFormatInputControl,
  createBooleanOperator,
  ReportRequestListModal
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';


export const MerchantReportFilter = () => {
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [userInfo] = useUserInfo();
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<PaymentAndTransactionValuesType>({
      resolver: zodResolver(paymentAndTransactionFormSchema),
      defaultValues: paymentAndTransactionInitialValues,
    });
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const [showTable, setShowTable] = useState(false)
  const {
    mutate: GetPaymentAndTransaction,
    isLoading: isGetPaymentAndTransactionLoading,
  } = useGetPaymentAndTransaction();
  const {
    mutate: PostRequestReportForTransactionList,
    isLoading: isPostRequestReportForTransactionList,
  } = usePostRequestReportForTransactionList();
  const {
    mutate: CancelPaymentAndTransaction,
    isLoading: isCancelPaymentAndTransactionLoading,
  } = useCancelPaymentAndTransaction();
  const {
    mutate: RefundPaymentAndTransaction,
    isLoading: isRefundPaymentAndTransactionLoading,
  } = useRefundPaymentAndTransaction();
  const { data: rawTransactionStatusList } = useGetTrxStatusSettingsList({});
  const { data: rawPayment3DTrxSettingsList } = useGetPayment3DTrxSettingsList(
    {}
  );
  const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant("ACTIVE");
  // const { data: rawAcquirerBankList } = useGetAcquirerBankList();
  const { mutate: getMemberVPosList, data: rawMemberVPosList } =
    useGetMemberVPosList();
  const { mutate: getMerchantVPosList, isLoading } = useGetMerchantVPosList();
  const setSnackbar = useSetSnackBar();
  useEffect(() => {
    setValue("startDate", dayjs().add(-1, "day"));
    setValue("endDate", dayjs());
  }, [setValue]);


  const [isReportListActive, setIsReportListActive] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [merchantBankList, setMerchantBankList] = useState([]);
  const [dynamicFilters, setDynamicFilter] = useState([]);
  const [bankList, setBankList] = useState([]);
  const transactionStatusList = useMemo(() => {
    return rawTransactionStatusList?.data?.map(
      (resourceType: { value: string; key: string }) => {
        return {
          label: resourceType.value,
          value: `${resourceType.key}`,
        };
      }
    );
  }, [rawTransactionStatusList?.data]);

  const convertTableFiltersToRequestFilter = (tableFilters) => {

    let convertedFilters = [];

    tableFilters.items.map((item) => {

      var findColumn = columns.find(x => x.field == item.field);

      convertedFilters.push({
        field: item.field,
        values: [item.value.toString()],
        valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
        operationType: mapReactMUIToFilterOperationTypes(item.operator)
      });
    });

    return convertedFilters;
  }

  const [reportFiles, setReportFiles] = useState([]);
  const getReportList = () => {
    postTransactionReportRequestList({
      reportType: 1
    })
      .then((data) => {
        setReportFiles(data.data.result);
        setIsReportListActive(true);
      })
  };

  const payment3DTrxSettingsList = useMemo(() => {
    return rawPayment3DTrxSettingsList?.data
      ?.filter((resourceType) => resourceType.status === "ACTIVE")
      .map((resourceType: { value: string; key: string }) => {
        return {
          label: resourceType.value,
          value: `${resourceType.key}`,
        };
      });
  }, [rawPayment3DTrxSettingsList?.data]);


  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);

  useEffect(() => {
    const savedFilter = localStorage.getItem("merchantReportFilterr");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);



  useEffect(() => {
    if (userInfo?.merchantId == 0) {

      getMemberVPosList(
        {
          orderBy: "CreateDate",
          orderByDesc: true,
          status: "ACTIVE",
        },
        {
          onSuccess: (data) => {
            const bankList = data?.data?.map(
              (bank: { bankCode: string; bankName: string }) => {
                return {
                  label: `${bank.bankName}`,
                  value: bank.bankCode,
                };
              }
            );
            setBankList(bankList);
          },
        }
      );
    } else {
      getMerchantVPosList(
        {
          size: paginationModel.pageSize,
          page: paginationModel.page,
          orderBy: "CreateDate",
          orderByDesc: true,
          status: "ACTIVE",
        },
        {
          onSuccess: (data) => {
            const bankList = data?.data?.result
              .filter((bank: { merchantId: number }) => {
                return bank.merchantId == Number(userInfo.merchantId);
              })
              .map(
                (bank: {
                  bankCode: string;
                  bankName: string;
                  merchantId: number;
                }) => {
                  return {
                    label: `${bank.bankName}`,
                    value: bank.bankCode,
                  };
                }
              );

            setBankList(bankList);
          },
        }
      );
    }
  }, [getMerchantVPosList, getMemberVPosList, userInfo.merchantId]);



  const [formValues, setFormValues] = useState<GetPaymentAndTransactionRequest | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false)
  const onSubmit = (data: PaymentAndTransactionValuesType) => {
    setPaginationModel({
      page: 0,
      pageSize: paginationModel.pageSize
    });
    setFilterAccordionExpand(false);
    setTableData(undefined);
    setShowTable(true)
    const req: GetPaymentAndTransactionRequest = {
      startDate: data?.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: data.endDate
        ? dayjs(data.endDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      // orderId: data.orderId,
      // cardNumber: data.cardNumber,
      // authCode: data.authCode,
      // status: data.status,
      // transactionType: data.transactionType,
      // bankCode: data.bankCode,
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId,
      filters: []
    };
    if (data.cardNumber) {
      req.filters.push({
        field: "maskedPan",
        values: [data.cardNumber],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.orderId) {
      req.filters.push({
        field: "orderId",
        values: [data.orderId],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.authCode) {
      req.filters.push({
        field: "authCode",
        values: [data.authCode],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.status) {
      req.filters.push({
        field: "status",
        values: [data.status],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.transactionType) {
      req.filters.push({
        field: "txnType",
        values: [data.transactionType],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.bankCode) {
      req.filters.push({
        field: "bankCode",
        values: [data.bankCode],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.filterMerchantId && data.filterMerchantId.length > 0) {

      var strMerchantId = data.filterMerchantId.map(x => `${x}`);

      req.filters.push({
        field: "merchantId",
        values: strMerchantId,
        operationType: 6,
        valueType: 2
      });
      // req.filterMerchantId = data.filterMerchantId;
    }
    setFormValues(req);
    setIsSubmitted(true);
  };


  useEffect(() => {
    if (!isSubmitted || !formValues) {
      return;
    }

    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
      size: paginationModel.pageSize,
      page: paginationModel.page,
    };

    if (requestPayload.filters) {
      requestPayload.filters = [
        ...requestPayload.filters,
        ...dynamicFilters
      ]
    }

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetPaymentAndTransaction(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [formValues, isSubmitted, queryOptions, paginationModel]);

  function RenderActionButton(transaction: any) {
    let buttonLabel = "";
    let buttonColor = "";

    if (transaction.status.toUpperCase() === "SUCCESS" && transaction.txnType.toUpperCase() !== "REFUND") {
      if (transaction.endOfDayFlag && !transaction.partialRefundFlag) {
        buttonLabel = "İade";
        buttonColor = "#EEAB00";
      } else if (!transaction.endOfDayFlag) {
        buttonLabel = "İptal";
        buttonColor = "#F5004A";
      }
    }

    return (
      <>
        <Link
          component="button"
          variant="body2"
          sx={{ color: buttonColor }}
          onClick={() => {
            setTableSelectedRow(transaction);
            buttonLabel === "İade" ? setIsRefundModalOpen(true) : setIsCancelModalOpen(true);
          }}
        >
          {buttonLabel}
        </Link>
      </>
    );
  }


  const handleCloseCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCloseRefundModal = () => {
    setIsRefundModalOpen(false);
    setValue("refundAmount", "");
  };

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );
  const handleCancelConfirm = () => {
    const req: CancelPaymentAndTransactionRequest = {
      merchantId: tableselectedRow?.filterMerchantId || 0,
      orderId: tableselectedRow?.orderId || "",
      description: "",
    };
    CancelPaymentAndTransaction(req, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });

          setPaginationModel(paginationModel);
          return;
          const requestParams = {
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            startDate: dayjs(getValues("startDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            endDate: dayjs(getValues("endDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            orderId: getValues("orderId"),
            cardNumber: getValues("cardNumber"),
            authCode: getValues("authCode"),
            status: getValues("status"),
            transactionType: getValues("transactionType"),
            bankCode: getValues("bankCode"),
            merchantId: +userInfo?.merchantId,
          }
          const filterMerchantId = getValues("filterMerchantId");
          if (filterMerchantId && (!Array.isArray(filterMerchantId) || filterMerchantId.length > 0)) {
            requestParams.filterMerchantId = filterMerchantId;
          }

          GetPaymentAndTransaction(
            requestParams,
            {
              onSuccess: (data) => {
                // Burada başladığım kodu yerleştirin
                if (data.isSuccess) {
                  if (data.data && data.data.length === 0) {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "success",
                      isOpen: true,
                      description: data.message,
                    });
                  }
                } else {
                  if (data.message === "Kayit bulunamadi") {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "error",
                      description: data.message,
                      isOpen: true,
                    });
                  }
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "İşlem sırasında bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseCancelModal();
  };

  const handleRefundConfirm = () => {
    const req: RefundPaymentAndTransactionRequest = {
      merchantId: tableselectedRow?.filterMerchantId || 0,
      orderId: tableselectedRow?.orderId || "",
      description: "",
      refundAmount:
        Number(getValues("refundAmount").replace(".", "").replace(",", "")) ||
        0,
    };
    RefundPaymentAndTransaction(req, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setPaginationModel(paginationModel);
          return;
          const requestParams = {
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            startDate: dayjs(getValues("startDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            endDate: dayjs(getValues("endDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            orderId: getValues("orderId"),
            cardNumber: getValues("cardNumber"),
            authCode: getValues("authCode"),
            status: getValues("status"),
            transactionType: getValues("transactionType"),
            bankCode: getValues("bankCode"),
            merchantId: +userInfo?.merchantId,
          }
          const filterMerchantId = getValues("filterMerchantId");
          if (filterMerchantId && (!Array.isArray(filterMerchantId) || filterMerchantId.length > 0)) {
            requestParams.filterMerchantId = filterMerchantId;
          }
          GetPaymentAndTransaction(
            requestParams,
            {
              onSuccess: (data) => {
                // Burada başladığım kodu yerleştirin
                if (data.isSuccess) {
                  if (data.data && data.data.length === 0) {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "success",
                      isOpen: true,
                      description: data.message,
                    });
                  }
                } else {
                  if (data.message === "Kayit bulunamadi") {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "error",
                      description: data.message,
                      isOpen: true,
                    });
                  }
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "İşlem sırasında bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseRefundModal();
  };
  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDescOption = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ? (
            <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              icon={RenderActionButton(params.row)}
            />
          ) : (
            <></>
          ),
        ],
      },
      {
        field: "filterMerchantId", headerName: "Üye İşyeri Numarası", width: 180,
        renderCell: (params) => params.value ? params.value.toString() : "",
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantName",
        headerName: "Üye İşyeri Adı",
        width: 300,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "mobilePos",
        headerName: "Mobil Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "vpos",
        headerName: "Sanal Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "pos",
        headerName: "Fiziksel Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "cepPos",
        headerName: "Cep Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "userCode", headerName: "Kullanıcı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "maskedPan", headerName: "Kart Numarası", width: 200, columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "orderId",
        headerName: "Sipariş Numarası",
        width: 400,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "originalOrderId",
        headerName: "Orjinal İşlem Numarası",
        width: 400,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "bankName", headerName: "Banka Adı", width: 300, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "currencyDesc", headerName: "Para Birimi", width: 150, columnType: RequestFilterValueTypeEnums.STRING,
        filterOperators: [createBooleanOperator(currencyDescOption)],
      },
      { field: "statusDesc", headerName: "İşlem Durumu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "systemDateFormatted", headerName: "İşlem Tarihi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "webUrl", headerName: "WEB Url", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "installmentCount", headerName: "Taksit Sayısı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },

      {
        field: "totalAmount",
        headerName: "Toplam Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "amount",
        headerName: "Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "totalComission",
        headerName: "Komisyon Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      { field: "txnTypeDesc", headerName: "İşlem Tipi", width: 150, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "paymentModel", headerName: "Ödeme Tipi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "requestIp", headerName: "İstek IP", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "description", headerName: "Açıklama", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "currency", headerName: "Para Birimi Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "cardHolderName",
        headerName: "İşlem Yapılan Kart Bilgisi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "failUrl", headerName: "Başarısız İşleme Ait URL", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "okUrl", headerName: "Başarılı İşleme Ait URL", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "merchantblocked",
        headerName: "Üye İşyeri Blokesi",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "merchantblockedday",
        headerName: "Üye İşyeri Bloke Günü",
        width: 200,
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantcommision",
        headerName: "Üye İşyeri Komisyonu %",
        type: 'decimalOnly',
        width: 200,
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantadditionalcommision",
        headerName: "Üye İşyeri Sabit Komisyonu",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "commissionFlag",
        headerName: "Komisyonu Son Kullanıcıya Yansıt",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "cardType", headerName: "Kart Tipi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardTypeDesc", headerName: "Kart Tipi Açıklama", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "authCode", headerName: "Otorizasyon Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "endOfDayFlag",
        headerName: "Gün Sonu",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "endOfDayId", headerName: "Gün Sonu ID", width: 200, columnType: RequestFilterValueTypeEnums.NUMBER },
      { field: "endOfDayDate", headerName: "Gün Sonu Tarihi", width: 200, columnType: RequestFilterValueTypeEnums.DATE },
      { field: "cardBankCode", headerName: "Kartın Banka Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardBankName", headerName: "Kartın Banka Adı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "bankResponseCode", headerName: "Banka Cevap Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "bankResponseCodeDesc", headerName: "Banka Cevap Açıklaması", width: 240, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "responseCode", headerName: "Cevap Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "responseMessage", headerName: "Cevap Açıklaması", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "createDateFormatted",
        headerName: "İşlemin Başlama Tarihi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "updateDateFormatted",
        headerName: "İşlem Bitiş Tarihi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "id", headerName: "ID", width: 200, columnType: RequestFilterValueTypeEnums.NUMBER },
      {
        field: "systemDateFormatted", headerName: "Sistem Tarihi", width: 200, columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "createDate", headerName: "Oluşturma Tarihi", width: 200,
        columnType: RequestFilterValueTypeEnums.DATE,
        renderCell: (params) => {
          if (!params.value) return ""; // Eğer değer null veya undefined ise boş döndür
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm:ss");
          if (formattedDate === "Invalid Date") return ""; // Eğer dönüşüm sonucu "Invalid Date" ise boş döndür
          return formattedDate;
        }
      },
    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    return;
    const req: GetPaymentAndTransactionRequest = {
      startDate: getValues("startDate")
        ? dayjs(getValues("startDate")).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: getValues("endDate")
        ? dayjs(getValues("endDate")).format("YYYY-MM-DD HH:mm:ss")
        : "",
      orderId: getValues("orderId"),
      cardNumber: getValues("cardNumber"),
      authCode: getValues("authCode"),
      status: getValues("status"),
      transactionType: getValues("transactionType"),
      bankCode: getValues("bankCode"),
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId
    };
    if (formMerchantId) {
      req.filterMerchantId = formMerchantId;
    } else if (data && data.filterMerchantId) {
      req.filterMerchantId = data.filterMerchantId;
    }
    GetPaymentAndTransaction(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };



  const keyMapping = {
    statusForExel: "statusForExel",
    txnTypeForExel: "txnTypeForExel"
  };
  const onSave = () => {
    const data = getValues();

    const req: GetPaymentAndTransactionRequest = {
      startDate: data?.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: data.endDate
        ? dayjs(data.endDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId,
      filters: [
        ...dynamicFilters
      ],
      reportType: 1
    };

    if (data.cardNumber) {
      req.filters.push({
        field: "maskedPan",
        values: [data.cardNumber],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.orderId) {
      req.filters.push({
        field: "orderId",
        values: [data.orderId],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.authCode) {
      req.filters.push({
        field: "authCode",
        values: [data.authCode],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.status) {
      req.filters.push({
        field: "status",
        values: [data.status],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.transactionType) {
      req.filters.push({
        field: "txnType",
        values: [data.transactionType],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.bankCode) {
      req.filters.push({
        field: "bankCode",
        values: [data.bankCode],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.filterMerchantId && data.filterMerchantId.length > 0) {

      var strMerchantId = data.filterMerchantId.map(x => `${x}`);

      req.filters.push({
        field: "merchantId",
        values: strMerchantId,
        operationType: 6,
        valueType: 2
      });
    }

    PostRequestReportForTransactionList(
      req,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setSnackbar({
              severity: "info",
              isOpen: true,
              description: data.data,
            });
          } else {
            if (data.message === "Kayit bulunamadi") {
              setSnackbar({
                severity: "info",
                isOpen: true,
                description: "Listede Kayıt Yoktur",
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );

    return;
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  const decimalFields = ['totalAmount', 'amount', 'totalComission'];

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      if (value === "false") {
        queryParams[key] = false;
      } else if (key === 'filterMerchantId') {
        if (value !== null && value !== undefined && value.toString().length > 0) {
          queryParams['filterSubMerchantId'] = Number(value);
        }
      } else if (value !== null && value !== undefined && value.toString().length > 0) {
        if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
          queryParams[key] = Number(parseFloat(value).toFixed(2));
        } else {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };




  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      localStorage.removeItem('merchantReportFilterr')
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
      localStorage.setItem('merchantReportFilterr', JSON.stringify(queryParams));
    }

    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

  const previousQueryParams = React.useRef({});

  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);

  const hasLoading =
    isGetPaymentAndTransactionLoading ||
    isCancelPaymentAndTransactionLoading ||
    isRefundPaymentAndTransactionLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <BaseFilterTableWithAccordion summary="Üye İşyeri Rapor" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            child={<Stack spacing={4}>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
                maxWidth={1308}
              >
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <DateTimePickerControl
                    sx={{ flex: 1 }}
                    id="startDate"
                    control={control}
                    label="Başlangıç Tarihi"
                    defaultValue={dayjs().add(-1, "day")}
                  />
                </FormControl>
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <DateTimePickerControl
                    sx={{ flex: 1 }}
                    id="endDate"
                    control={control}
                    label="Bitiş Tarihi"
                    defaultValue={dayjs()}
                  />
                </FormControl>
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  {transactionStatusList && (
                    <Controller
                      name="status"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedStatus = transactionStatusList.find(
                          (option) => option.value === value
                        );

                        return (
                          <Autocomplete
                            id="status"
                            options={transactionStatusList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedStatus || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="İşlem Durumu" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>

                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <InputControl
                    label="Sipariş Numarası"
                    control={control}
                    id="orderId"
                  />
                </FormControl>
              </Stack>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
                maxWidth={1308}
              >
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    label="Kart Numarası"
                    control={control}
                    id="cardNumber"
                  />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    label="Otorizasyon Kodu"
                    control={control}
                    id="authCode"
                  />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  {payment3DTrxSettingsList && (
                    <Controller
                      name="transactionType"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedTransactionType =
                          payment3DTrxSettingsList.find(
                            (option) => option.value === value
                          );

                        return (
                          <Autocomplete
                            id="transactionType"
                            options={payment3DTrxSettingsList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedTransactionType || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="İşlem Tipi" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  {bankList && (
                    <Controller
                      name="bankCode"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedBank = bankList.find(
                          (option) => option.value === value
                        );

                        return (
                          <Autocomplete
                            id="bankCode"
                            options={bankList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedBank || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="POS Bankası" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>
              </Stack>

              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
                maxWidth={1308}
              >
                <FormControl sx={{ flex: 1 }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="filterMerchantId"
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          id="merchant-multi-checkbox"
                          options={merchantList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => {
                            // Seçilen tüm değerlerin dizisini güncelliyoruz
                            field.onChange(newValue.map((item) => item.value));
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.value}>
                              <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                          )}
                        />
                      )}
                    />
                  )}
                </FormControl>
                <div style={{ flex: 1 }} /> {/* empty space filler */}
                <div style={{ flex: 1 }} /> {/* empty space filler */}
                <div style={{ flex: 1 }} /> {/* empty space filler */}
              </Stack>


              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? "100%" : "auto"}
                maxWidth={1308}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />
          <Stack flex={1} mt={2} >
            {showTable && (
              <>

                <Table
                  columnVisibilityConfigKey="merchantReportFilterrColumnVisibilityKey"
                  filterKey="merchantReportFilterr"
                  hasActiveFilters={hasActiveFilters}
                  handleFilterChange={handleFilterChange}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems || 0}
                  customLabelDisplayedRows={true}
                  // sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 , height: "100%"}}
                  isRowSelectable={() => false}
                  // disableColumnMenu
                  rows={tableData?.result || []}
                  autoHeight={false}
                  columns={columns}
                  exportFileName="Üye İşyeri Raporu"
                  onSave={null}
                  extraToolbarButton={<>
                    <MaterialButton sx={{ marginLeft: 2 }} onClick={() => onSave()}>
                      <AddchartIcon color="primary" />
                      RAPOR OLUŞTUR
                    </MaterialButton>
                    <MaterialButton sx={{ marginLeft: 2 }} onClick={() => { getReportList(); }}>
                      <BarChartIcon color="primary" />
                      RAPORLAR
                    </MaterialButton>
                  </>}
                  getRowClassName={(params) => {
                    if ((params.row.status === 'VOID' && params.row.txnType.toUpperCase() === 'AUTH') ||
                      (params.row.status === 'SUCCESS' && params.row.txnType.toUpperCase() === 'REFUND')) {
                      return 'blocked-row';
                    } else if (params.row.status === 'Unmatched') {
                      return 'unmatched-row';
                    } else {
                      return '';
                    }
                  }}
                />
                <ReportRequestListModal
                  isOpen={isReportListActive}
                  onClose={() => { setIsReportListActive(false); }}
                  title="Raporlar"
                  reportFiles={reportFiles}
                  closeButtonText="Kapat"
                ></ReportRequestListModal>
                <DeleteConfirmModal
                  isOpen={isCancelModalOpen}
                  onClose={handleCloseCancelModal}
                  title="İptal Onayı"
                  content="Seçili kaydı iptal etmek istiyor musunuz?"
                  confirmButtonText="Evet"
                  closeButtonText="Hayır"
                  onConfirm={() => handleCancelConfirm()}
                ></DeleteConfirmModal>

                <DeleteConfirmModal
                  isOpen={isRefundModalOpen}
                  onClose={handleCloseRefundModal}
                  title="İade Onayı"
                  content="Seçili kaydı iade etmek istiyor musunuz?"
                  confirmButtonText="Evet"
                  closeButtonText="Hayır"
                  onConfirm={() => handleRefundConfirm()}
                >
                  <FormControl sx={{ width: 290, mt: 3 }}>
                    <NumericFormatInputControl
                      sx={{ flex: 1 }}
                      label="İade Tutarı"
                      control={control}
                      id="refundAmount"
                      adornmentText="TL"
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale
                    />
                  </FormControl>
                </DeleteConfirmModal>
              </>
            )}
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
